import type { RootState } from '@src/core/store';
import { makeSteps, productAttributeTypesSelector } from '@src/stores/product';
import { orderedEmbedSlots } from './orderedEmbedSlots';
import { productIncludesLanguageSlot } from './productIncludesLanguageSlot';
import { ProductBookingSlot } from '../types/productBookingSlot';

export const getOrderedEmbedSlots = (widgetId: string, state: RootState): ProductBookingSlot[] => {
  const adder = state.product.adderState[widgetId];
  const productId = adder?.productId;

  if (!adder || !productId) {
    return [];
  }

  const product = state.product.products[productId]!;
  const steps = makeSteps(widgetId, state);
  const includeLanguage = productIncludesLanguageSlot(productId, state);
  const attributeTypes = productAttributeTypesSelector(productId)(state);

  return orderedEmbedSlots(product, steps, includeLanguage, attributeTypes);
};
